<section class="ufos-history" aria-label="UFOs history" [attr.aria-busy]="loading">
  <header class="history-header">
    <div>
      <div class="title-line">
        <h2>UFOs history</h2>
        <span class="source-badge">UFOs via Roswell</span>
      </div>
      <p>Original UFOs entries, kept separate from AMS audit history.</p>
      <p *ngIf="workOrderNumber">
        Whole UFOs work order <strong>{{ workOrderNumber }}</strong> · oldest entries first.
      </p>
    </div>
    <button type="button" (click)="refresh()" [disabled]="loading">Refresh UFOs history</button>
  </header>

  <p class="history-error" role="alert" *ngIf="error">{{ error }}</p>
  <p class="history-status" role="status" *ngIf="loading">Loading UFOs history…</p>
  <p class="history-status" *ngIf="hasLoaded && !loading && !error && entries.length === 0">
    No history entries are recorded in UFOs for this work order.
  </p>

  <ol class="history-list">
    <li class="history-entry" *ngFor="let entry of entries">
      <div class="entry-heading">
        <div>
          <span class="field-label">Recorded in UFOs</span>
          <strong>{{ entry.recordedAt }}</strong>
        </div>
        <div class="entry-author">
          <span>UFOs user: <strong>{{ entry.author }}</strong></span>
          <span>Type: {{ entry.type }}</span>
        </div>
      </div>

      <p class="entry-note" *ngIf="entry.notes">{{ entry.notes }}</p>

      <div class="change-scroll" *ngIf="entry.changes.length">
        <table>
          <caption class="visually-hidden">Changes recorded in UFOs</caption>
          <thead>
            <tr>
              <th scope="col">Field</th>
              <th scope="col">Before</th>
              <th scope="col">After</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let change of entry.changes">
              <th scope="row">{{ change.label }}</th>
              <td>{{ change.before || 'Not recorded' }}</td>
              <td>{{ change.after || 'Not recorded' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="muted" *ngIf="!entry.changes.length && !entry.notes">
        No changes to status, parties or amounts are recorded in this entry.
      </p>
      <details class="recorded-values" *ngIf="entry.recordedValues.length">
        <summary>Recorded UFOs values</summary>
        <dl>
          <div *ngFor="let value of entry.recordedValues">
            <dt>{{ value.label }}</dt>
            <dd>{{ value.value }}</dd>
          </div>
        </dl>
      </details>
    </li>
  </ol>

  <footer class="history-footer" *ngIf="hasLoaded">
    <p>Dates and user IDs above are reported by UFOs.</p>
    <p *ngIf="retrievedAt">Retrieved {{ retrievedAt | date:'medium' }}.</p>
    <p *ngIf="coverage">{{ coverage }}</p>
    <button type="button" *ngIf="nextCursor" (click)="loadMore()" [disabled]="loading">
      Load more UFOs entries
    </button>
  </footer>
</section>
